import { DataService } from './dataService'
const menuService = {
	addMenu: async (data) => {
		return DataService.post('/admin/add_saas_menu', data)
	},
	getMenu: async (data) => {
		return DataService.get('/admin/get_saas_menu', data)
	},
	updateMenu: async (data) => {
		return DataService.post('/admin/update_saas_menu', data)
	},
	updateMenuStatus: async (data) => {
		return DataService.post('/admin/update_saas_menu_status', data)
	},
	deleteMenu: async (data) => {
		return DataService.post('/admin/delete_saas_menu', data)
	},
}

export default menuService
